// Set to `true` by a page that previews the Hero inside a resizable frame (business-utils'
// Hero Visualizer): the mobile/desktop image then follows the frame's width instead of the viewport's.
export const HERO_CONTAINER_PREVIEW_CONTEXT = 'hero-container-preview';
